import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Style from "./FamilyUsersPrice.module.scss";
import moment from "moment";
import Assets from "../Layouts/Assets";
import ProgressBar from "react-bootstrap/ProgressBar";
import { Link } from "react-router-dom";
import { getUserBasicData } from "../../store/slices/GetStarted/userBasicDataSlice";
const FamilyUsersPrice = ({ isCollapsed }) => {
  const { userProfileData } = useSelector((state) => state.userData);
  const dispatch = useDispatch();
  useEffect(() => {
    if(userProfileData?.is_package){
    dispatch(getUserBasicData());
  }
  }, [userProfileData?.is_package]);
  return (
    <>
      {!isCollapsed ? (
        <div
          className={`${Style.family_users} amily-users-ad`}
          style={{
            "--bgimg": "url(" + Assets.dashboardLeftBarUsageBg + ")",
          }}
        >
          {userProfileData?.expiry_at && (
            <p className={Style.family_users_expiry}>
              Expires on {userProfileData?.expiry_at}
            </p>
          )}
          <div className={Style.family_users_title}>
            <span>{userProfileData?.email}</span>
          </div>
          {userProfileData?.is_package && (
            <Link className="btn btn-sm btn-outline-black" to="/plans">
              Renew
            </Link>
          )}
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default FamilyUsersPrice;
